export default __webpack_public_path__ + "media/images/icon_lock_open-09dd9ea3c72e7c5b2a106937ac1d854d.svg";